var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.989 0a7.998 7.998 0 0 1 7.988 7.989A7.989 7.989 0 1 1 7.99 0zm2.76 4.71a.726.726 0 0 0-.707.197L7.99 6.962 5.935 4.907a.726.726 0 1 0-1.027 1.027L6.962 7.99l-2.054 2.054a.726.726 0 0 0 1.027 1.027l2.054-2.054 2.053 2.054a.726.726 0 1 0 1.027-1.027L9.016 7.99l2.053-2.055a.726.726 0 0 0-.32-1.225z",
    fill: "#E7342D",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.96c6652b590c29bdfe2add4e9aa8b496.svg";
export { ForwardRef as ReactComponent };